// services/getSignedUrl.js
export const getSignedUrl = async (publicId, resourceType = "image") => {
  const res = await fetch("/api/upload/signed-url", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ publicId, resourceType }),
  });
  const data = await res.json();
  return data.signedUrl;
};